import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://public.readdy.ai/ai/img_res/417067b6c22e32312fe9b2a9db08defd.jpg)`,
        }}
      />
      {/* Light left-side gradient only — keeps image visible */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-32 pt-44">
        <div className="max-w-2xl">

          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-[#10B981] rounded-full px-4 py-1.5 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-flashlight-fill text-white text-xs"></i>
            </div>
            <span className="text-white font-body font-700 text-xs tracking-wider uppercase">Same-Day Inspections Available</span>
          </div>

          <h1
            className="font-headline font-900 text-white text-4xl lg:text-5xl xl:text-6xl leading-[1.08] mb-6"
            style={{ textShadow: "0 2px 4px rgba(0,0,0,0.9), 0 4px 24px rgba(0,0,0,0.8), 0 1px 2px rgba(0,0,0,1)" }}
          >
            Stop Roof Leaks Before They{" "}
            <span className="text-[#10B981]">Cost You Thousands</span>
          </h1>
          <p
            className="text-white font-body font-600 text-lg lg:text-xl leading-relaxed mb-8"
            style={{ textShadow: "0 1px 3px rgba(0,0,0,1), 0 2px 16px rgba(0,0,0,0.9)" }}
          >
            Colorado Springs' most trusted roofing team. Fast response, honest inspections, and long-lasting repairs that protect your home — done right the first time.
          </p>

          {/* Trust indicators row */}
          <div className="flex flex-wrap gap-3 mb-10">
            {[
              { icon: "ri-shield-check-fill", text: "Licensed & Insured" },
              { icon: "ri-flashlight-fill", text: "Emergency Repairs Available" },
              { icon: "ri-star-fill", text: "5-Star Rated" },
              { icon: "ri-home-4-fill", text: "500+ Roofs Completed" },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${badge.icon} text-[#10B981] text-sm`}></i>
                </div>
                <span
                  className="text-white font-body font-700 text-sm whitespace-nowrap"
                  style={{ textShadow: "0 1px 3px rgba(0,0,0,1), 0 2px 8px rgba(0,0,0,0.9)" }}
                >
                  {badge.text}
                </span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/#contact"
              className="inline-flex items-center justify-center gap-2 bg-[#10B981] hover:bg-emerald-500 text-white font-body font-700 text-base px-9 py-4 rounded-md cursor-pointer whitespace-nowrap transition-all shadow-xl shadow-emerald-900/40"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-eye-line text-white text-sm"></i>
              </div>
              Get My Free Roof Inspection
            </Link>
            <a
              href="tel:407-408-0577"
              className="inline-flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 border-2 border-white/50 hover:border-white text-white font-body font-700 text-base px-8 py-4 rounded-md cursor-pointer whitespace-nowrap transition-all"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-[#10B981] text-sm"></i>
              </div>
              Call (407) 408-0577
            </a>
          </div>

          {/* Urgency note */}
          <p
            className="text-white font-body font-600 text-sm mt-5"
            style={{ textShadow: "0 1px 3px rgba(0,0,0,1), 0 2px 8px rgba(0,0,0,0.9)" }}
          >
            <i className="ri-time-line mr-1"></i>
            Most inspections scheduled within 24 hours — Don't let damage spread.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5">
        <span className="text-white/40 font-body text-xs tracking-wider uppercase">Scroll</span>
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40 text-base animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}
